<script lang="ts" setup>
const _props = defineProps<{
  open?: boolean
  megaMenus?: any
  burgerItems?: any
  arrowLinks?: any
  callToAction?: unknown
}>()

const route = useRoute()
</script>

<template>
  <aside class="fixed top-0 left-0 h-dvh w-screen overflow-auto bg-(--green-1) text-(--sand)">
    <div class="relative z-2 flex h-full flex-col justify-between pt-16 pb-5">
      <div class="px-bleed flex flex-col">
        <CommonBasicLink
          v-if="callToAction"
          :link="callToAction"
          class="my-8 flex w-full items-center justify-center rounded-sm bg-(--sand) px-4.5 py-4 font-bold text-(--green-1)"
          >{{ callToAction.label }}</CommonBasicLink
        >

        <ElementsAccordion v-for="megaMenu in megaMenus" :key="megaMenu._key" class="group px-0">
          <template #summary>
            <div
              class="relative flex list-none items-center justify-between border-b border-(--sand)/15 py-5"
            >
              <span class="flex text-base">
                {{ megaMenu.title }}
              </span>
              <IconsChevronDown class="w-4 transition-transform group-open:rotate-180" />
            </div>
          </template>

          <template #content>
            <div class="pt-6">
              <nav v-for="menu in megaMenu.items" :key="menu._key" class="grid gap-4 pb-6">
                <h2 class="font-display pb-4 text-lg">{{ menu.title }}</h2>
                <CommonBasicLink
                  v-for="item in menu.items"
                  :key="item._key"
                  :link="item"
                  class="relative flex items-center gap-3"
                >
                  <span :class="[{ 'text-(--green-3)': route.path == item.page?.url }]">
                    {{ item.label }}
                  </span>
                </CommonBasicLink>
              </nav>
            </div>
          </template>
        </ElementsAccordion>
      </div>
      <div class="mt-16 px-5">
        <div class="">
          <nav>
            <ElementsLinkList :items="burgerItems" :mark-active="true" />
          </nav>
          <nav class="mt-5">
            <CommonBasicLink
              v-for="(item, index) in arrowLinks"
              :key="index"
              :link="item"
              class="flex w-full items-center justify-between border-t border-(--theme-fg)/15 py-5 text-base"
            >
              {{ item.label }}
              <IconsArrowRight class="size-4" />
            </CommonBasicLink>
            <div
              class="language-wrapper flex w-full items-center justify-between border-t border-(--theme-fg)/15 py-5 text-base font-medium"
            >
              <LanguageSelector />
              <IconsArrowRight class="size-4" />
            </div>
          </nav>
        </div>
      </div>
    </div>
  </aside>
</template>
